import { Injectable } from '@angular/core';
import 'rxjs/add/observable/fromPromise';
import * as ABI from 'ethereumjs-abi';
import * as Util from 'ethereumjs-util';
import * as math from 'mathjs';
import { Logger } from '@app/core/logger.service';

const logger = new Logger('@app:ether-interface.service.ts');

@Injectable()
export class EtherInterfaceService {

  public abi = ABI;
  private dummyPrivateKEy: string = '9a0ec368bd3e6b0dcf4877056af32ccf7c6bdd681cf1561dc60bc7ae0c2e5f6f';

  constructor(
  ) {
    logger.info('service constructed');
  }

  static prefix(hexString: string): string {
    if (hexString.startsWith('0x')) {
      return hexString;
    }
    return '0x' + hexString;
  }

  getStateDataHex(winBalance: number, gameCount: number) {
    return this.abi.soliditySHA3(['int128', 'uint128'], [Math.round(winBalance), gameCount]).toString('hex');
  }

  getSign(str: string, privateKey: any = null, binary: boolean = false) {
    if (str.length !== 64) {
      str = Util.sha3(str).toString('hex');
    }
    return this.createSignature(str, privateKey, binary);
  }

  createSignature(str: string, privateKey: any = null, binary: boolean = false) {
    logger.info('creating signature');
    if (privateKey === null) {
      privateKey = this.dummyPrivateKEy;
    }
    const sign = Util.ecsign(new Buffer(str, 'hex'), new Buffer(privateKey, 'hex'));
    if (!binary) {
      // Convert it to buffer, because sockets doesnt support typings
      sign.r = new Buffer(sign.r).buffer;
      sign.s = new Buffer(sign.s).buffer;
    }
    logger.info('signature created', sign);
    return sign;
  }

  edgToEdgwithDec(value: number): number {
    return Math.floor(Number(math.multiply(math.bignumber(value), math.bignumber(100000))));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/ether-interface.service.ts